import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { APIConfigMapping, FONTS, HTTPAPIConfig, VlDataService, VlHttpService, isNullOrUndefined } from 'shared-library';
import { debounceTime, distinctUntilChanged, merge } from 'rxjs';
import { WebServiceService } from '../../services/web-service.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'lib-web-theme',
  templateUrl: './web-theme.component.html',
  styleUrls: ['./web-theme.component.scss']
})
export class WebThemeComponent {
  themeColors!: FormGroup;
  postFontData!: FormGroup;
  fonts: any[] = [];
  visible: boolean = false;
  displayTheme = false;
  allThemes: any[] = [];
  cancelEnable: boolean = false;
  spinnerActive: boolean = false;

  constructor(private _formBuilder: FormBuilder,
    private sharedService: WebServiceService,
    private dataService: VlDataService,
    private httpService: VlHttpService,
    private toaster: ToastrService
  ) {

  }

  ngOnInit(): void {
    this.spinnerActive = true;
    this.displayTheme = false;
    this.formbuilder();
    this.getAllThemes();
  }

  formbuilder() {
    this.themeColors = this._formBuilder.group({
      primaryColor: "#0061A6",
      secondaryColor: "#6C5778",
      defaultBackgroundColor: "#FAF9FD",
      defaultTextColor: "#45474A",
      themeName: 'M3 Baseline Light'
    });

    this.postFontData = this._formBuilder.group({
      headingFont: ["", Validators.required],
      bodyFont: ["", Validators.required]
    })
  }

  getColorValue(controlName: string) {
    return this.themeColors.get(controlName)?.value || "#000000";
  }

  getChangedColorValue(colorName: string) {
    this.sharedService.setThemesData(colorName, this.getColorValue(colorName));
  }
  changesSubscribe() {
    merge(
      this.themeColors.valueChanges.pipe(debounceTime(500), distinctUntilChanged()),
      this.postFontData.valueChanges.pipe(debounceTime(500), distinctUntilChanged())
    ).subscribe((formValue) => {
      let colorValues: any[] = ['primaryColor', 'secondaryColor', 'defaultBackgroundColor', 'defaultTextColor', 'themeName'];
      colorValues.map((data: any) => {
        this.sharedService.setThemesData(data, this.getColorValue(data));
      })
      this.sharedService.setThemesData('headingFontStyle', this.postFontData.getRawValue()?.headingFont);
      this.sharedService.setThemesData('bodyFontStyle', this.postFontData.getRawValue()?.bodyFont);
      // this.updateThemeData();
    });
  }


  updateThemeData() {
    let userDetails: any = JSON.parse(localStorage.getItem("userInfo") || '');
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['EDIT_THEME']);
    apiConfig.postData = {
      "theme_id": this.sharedService.getApplicationDataById().theme_id,
      "theme_name": this.themeColors.getRawValue()?.themeName,
      "primary_color": this.themeColors.getRawValue().primaryColor,
      "secondary_color": this.themeColors.getRawValue().secondaryColor,
      "background_color": this.themeColors.getRawValue().defaultBackgroundColor,
      "text_color": this.themeColors.getRawValue().defaultTextColor,
      "font_heading": this.postFontData.getRawValue().headingFont,
      "font_body": this.postFontData.getRawValue()?.bodyFont,
      "last_modified_by": userDetails?.userId,
    }

    this.httpService.placeAPICall(apiConfig).subscribe({
      next: (data: any) => {
        this.sharedService.setThemeData({ ...this.postFontData.getRawValue(), ...this.themeColors.getRawValue() })
        this.toaster.success('Applied Sucessfully');
      },
      error: (err: any) => {
        this.toaster.error('Something Went Wrong!');
      }
    })
  }

  getThemesData() {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['GET_THEME_BYID']);
    apiConfig.postData = {
      "id": this.sharedService.getApplicationDataById().theme_id,
    }
    this.httpService.placeAPICall(apiConfig).subscribe({
      next: (data: any) => {
        this.fonts = FONTS
        this.postFontData.patchValue({
          headingFont: data.font_heading,
          bodyFont: data.font_body
        })
        this.themeColors.patchValue({
          primaryColor: data.primary_color,
          secondaryColor: data.secondary_color,
          defaultBackgroundColor: data.background_color,
          defaultTextColor: data.text_color,
          themeName: data?.theme_name
        })
        this.sharedService.setThemeData({ ...this.postFontData.getRawValue(), ...this.themeColors.getRawValue() })
        this.visible = true;
        this.spinnerActive = false;
        this.changesSubscribe();
      },
      error: (err: any) => {
        this.spinnerActive = false;
      }
    })
    this.displayTheme = true;
  }
  setThemeData() {
    this.displayTheme = true;
    this.fonts = FONTS
    this.postFontData.patchValue(this.sharedService.getThemeData());
    this.themeColors.patchValue(this.sharedService.getThemeData());
    this.visible = true;
    let colorValues: any[] = ['primaryColor', 'secondaryColor', 'defaultBackgroundColor', 'defaultTextColor'];
    colorValues.map((data: any) => {
      this.sharedService.setThemesData(data, this.getColorValue(data));
    })
    this.sharedService.setThemesData('headingFontStyle', this.postFontData.getRawValue()?.headingFont);
    this.sharedService.setThemesData('bodyFontStyle', this.postFontData.getRawValue()?.bodyFont);
    this.spinnerActive = false;
    this.changesSubscribe();
  }
  onHeadingFontChange(data: any) {
    this.sharedService.setThemesData('headingFontStyle', data?.value);
  }
  onBodyFontChange(data: any) {
    this.sharedService.setThemesData('bodyFontStyle', data?.value);
  }
  onThemeChange(_event: any) {
    this.cancelEnable = true;
    const data = this.allThemes.find((ele: any) => ele['theme_name'] == _event.value);
    const themesColors = {
      primaryColor: data.primary_color,
      secondaryColor: data.secondary_color,
      defaultBackgroundColor: data.background_color,
      defaultTextColor: data.text_color,
    }
    const fontData = {
      headingFont: data.font_heading,
      bodyFont: data.font_body
    }
    this.postFontData.patchValue(fontData);
    this.themeColors.patchValue(themesColors);
  }
  getAllThemes() {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(
      APIConfigMapping["GET_THEMES"]
    );
    this.httpService.placeAPICall(apiConfig).subscribe({
      next: (data: any) => {
        this.allThemes = data;
      },
      complete: () => {
        if (isNullOrUndefined(this.sharedService.getThemeData())) {
          this.getThemesData();
        } else {
          this.setThemeData();
        }
      },
      error: (err: any) => {
        this.spinnerActive = false;
      },
    });
  }
  revertBackTheme() {
    this.postFontData.patchValue(this.sharedService.getThemeData());
    this.themeColors.patchValue(this.sharedService.getThemeData());
    let colorValues: any[] = ['primaryColor', 'secondaryColor', 'defaultBackgroundColor', 'defaultTextColor'];
    colorValues.map((data: any) => {
      this.sharedService.setThemesData(data, this.getColorValue(data));
    })
    this.sharedService.setThemesData('headingFontStyle', this.postFontData.getRawValue()?.headingFont);
    this.sharedService.setThemesData('bodyFontStyle', this.postFontData.getRawValue()?.bodyFont);
  }
}
